<div *ngIf="!isBanner">
  <article class="session-from-wrapper">
    <h2 class="title" *ngIf="showTitle">
      {{
        getSignUpActive && !resetMode
          ? "Regístrate y accede a todos los beneficios de Mi farmatodo"
          : selectMethodMode
          ? "Recuperar contraseña"
          : validateCodeMode
          ? ""
          : selectEmailMode
          ? "Selecciona un Email para iniciar sesión"
          : "Inicia sesión"
      }}
    </h2>
    <section [ngClass]="{ 'offset-md-2 col-md-8': isModalStyle}">
      <app-sign-up-form
        *ngIf="getSignUpActive"
        [idPrefix]="idPrefix"
        [isModal]="isModal"
        [customerData]="customerData"
        (signedUp)="onSuccess($event, 'signUp')"
        (openLogin)="onOpenLogin($event)"
        (emailErrorRegister)="emailErrorRegister($event)"
      ></app-sign-up-form>

      <app-login-form
        *ngIf="!getSignUpActive"
        [idPrefix]="idPrefix"
        [openModal]="modalStatus"
        [isModal]="isModal"
        (resetPasswordMode)="onResetPasswordMode($event)"
        (selectMethodMessageMode)="onSelectMethodMessageMode($event)"
        (validateCodeMode)="onValidateCodeMode($event)"
        (selectEmailMode)="onSelectEmailMode($event)"
        (onValidateCode)="onValidateCodeMode($event)"
        (loggedIn)="onSuccess($event, 'login')"
        (openSignUp)="onOpenSignUp($event)"
        (resetPassword)="onSuccess($event)"
        (userNotFound)="onUserNotFound($event)"
        (openResetPasswordModal)="onOpenResetPassword($event)"
        (errorEmailTitle) = "errorEmailTitle($event)"
        [emailErrorRegister]="emailError"
      ></app-login-form>
    </section>
  </article>

  <app-reset-password
    *ngIf="!isModal"
    [resetModalStatus]="openResetModal"
    [idPrefix]="idPrefix"
    (passwordReset)="onSuccess($event)"
  ></app-reset-password>

</div>

<div *ngIf="isBanner">
  <app-login-form
        *ngIf="!getSignUpActive"
        [idPrefix]="idPrefix"
        [openModal]="modalStatus"
        [isModal]="isModal"
        [isBanner]="isBanner"
        (resetPasswordMode)="onResetPasswordMode($event)"
        (selectMethodMessageMode)="onSelectMethodMessageMode($event)"
        (validateCodeMode)="onValidateCodeMode($event)"
        (selectEmailMode)="onSelectEmailMode($event)"
        (onValidateCode)="onValidateCodeMode($event)"
        (loggedIn)="onSuccess($event, 'login')"
        (openSignUp)="onOpenSignUp($event)"
        (resetPassword)="onSuccess($event)"
        (userNotFound)="onUserNotFound($event)"
        (openResetPasswordModal)="onOpenResetPassword($event)"
      ></app-login-form>
</div>
